module.exports = __webpack_public_path__ + "img/branch_icon.e21e6377.svg";